(function () {
  function wrapBannerLetters() {
    document.querySelectorAll('.banner--desktop-transparent .banner__text p').forEach(function (paragraph) {
      if (paragraph.dataset.lettersWrapped === 'true') return;

      var text = paragraph.textContent || '';
      paragraph.textContent = '';

      Array.prototype.forEach.call(text, function (char, index) {
        var span = document.createElement('span');
        span.className = 'banner-letter';
        span.textContent = char === ' ' ? '\u00A0' : char;
        span.style.animationDelay = index * 0.12 + 's';
        paragraph.appendChild(span);
      });

      paragraph.dataset.lettersWrapped = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapBannerLetters);
  } else {
    wrapBannerLetters();
  }
})();
